const normalize = (value) => (value || '').toString().trim().toLowerCase()

const fullName = (person) => `${person.firstname || ''} ${person.lastname || ''}`.trim()

export const initials = (firstname, lastname) => {
    const letters = [firstname, lastname]
        .map(part => (part || '').trim().charAt(0).toUpperCase())
        .join('')

    return letters || '?'
}

export const accessCount = (ids, statusMap) => {
    const map = statusMap || {}

    return {
        on: ids.filter(id => map[`${id}`] === true).length,
        total: ids.length
    }
}

const personMatches = (person, query) => (
    normalize(fullName(person)).includes(query) || normalize(person.title).includes(query)
)

export const filterPeople = (people, query) => {
    const needle = normalize(query)

    if (!needle) {
        return people
    }

    return people.filter(person => personMatches(person, needle))
}

export const filterLocations = (businesses, query) => {
    const needle = normalize(query)

    return businesses.reduce((result, business) => {
        const employees = (business.users || []).filter(user => !user.is_dummy)
        const locationMatches = !needle
            || normalize(business.name).includes(needle)
            || normalize(business.address).includes(needle)

        if (locationMatches) {
            result.push({ business, employees })

            return result
        }

        const matchingEmployees = employees.filter(user => personMatches(user, needle))

        if (matchingEmployees.length > 0) {
            result.push({ business, employees: matchingEmployees })
        }

        return result
    }, [])
}

export const disabledReason = ({ account, locationOn, grantable }) => {
    if (!account) {
        return __('Turn on a reviews provider first.')
    }
    if (locationOn === false) {
        return __('Turn on the location first.')
    }
    if (grantable === false) {
        return __('Cannot be given access with ShoutAboutUs.')
    }

    return null
}

export const toggleTargets = (items, turnOn) => items
    .filter(item => !item.disabled && Boolean(item.on) !== turnOn)
    .map(item => item.id)

export const runSequentially = async (ids, fn, onProgress = () => {}) => {
    const failed = []
    let done = 0

    for (let index = 0; index < ids.length; index++) {
        const id = ids[index]

        try {
            const result = await fn(id)

            if (result && result.ok === false) {
                failed.push(id)
            } else {
                done++
            }
        } catch (error) {
            console.error(error)
            failed.push(id)
        }

        onProgress(index + 1, ids.length)
    }

    return { done, failed }
}
